<template>
  <div class="p-2">
    <div class="bg-gray-200 rounded-md p-4 text-lg font-italic"
      v-if="emptySchedule">
      No Schedule Data
    </div>
    <div
      v-else>
      <div class="flex flex-col"
        v-if="scheduleData !== undefined">
        <div class="p-2">
          <span class="text-xl">Student Info</span>
        </div>
        <div class="bg-gray-50 shadow-sm rounded-md p-2 mb-4">
          <StudentInfoDisplay
            :studentInfo="studentInfoData"
            :studentInfoDiff="studentInfoDataDiff"
          />
        </div>
      </div>
      <div v-if="scheduleData !== undefined">
        <ScheduleWeekdays
          :defaultExpandAllDays="defaultExpandAllDays"
          :scheduleData="scheduleData"
          :scheduleDataDiff="scheduleDataDiff"
        />
      </div>
      <Spinner
        v-if="scheduleData === undefined"
        message="Loading Schedule"
        :size="16"
      />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

import Spinner from '../Spinner.vue'

import ScheduleWeekdays from './sections/ScheduleWeekdays.vue'
import StudentInfoDisplay from './sections/StudentInfoDisplay.vue'

const weekdayInitialsTemplate = ['Su', 'M', 'T', 'W', 'R', 'F', 'Sa']

export default {
  components: {
    Spinner,
    ScheduleWeekdays,
    StudentInfoDisplay,
  },
  props: {
    emptySchedule: {
      type: Boolean,
      default: false,
    },
    defaultExpandAllDays: {
      type: Boolean,
      default: false,
    },
    scheduleData: {
      type: Object,
      default: undefined,
    },
    scheduleDataDiff: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      currentWeekdayIndex: this.getWeekdayIndex(),
      weekdayInitials: ['Su', 'M', 'T', 'W', 'R', 'F', 'Sa'],
      weekdaySlots: [],
      expandAllDays: false,
    }
  },
  methods: {
    getWeekdayIndex() {
      const dayInt = new Date().getDay()
      if (dayInt === 0 || dayInt === 6) {
        return 0
      }
      return dayInt - 1
    },
    assignScheduleData(weekdays) {
      this.weekdayInitials = cloneDeep(weekdayInitialsTemplate)

      var satIndex = weekdays.findIndex(elem => elem.weekday === 'sat')
      var sunIndex = weekdays.findIndex(elem => elem.weekday === 'sun')
      if (satIndex < 0 && sunIndex < 0) {
        this.weekdayInitials.shift()
        this.weekdayInitials.pop()
      }
    },
  },
  mounted() {},
  computed: {
    studentInfoData() {
      return this.scheduleData.info
    },
    studentInfoDataDiff() {
      return this.scheduleDataDiff?.info
    },
  },
}
</script>
